import tw from 'twin.macro';
import TooltipIcon from '../shared/tooltipIcon';
import 'twin.macro';

const LabelWithTooltip = ({
  label,
  tooltipText,
  hasTooltip = false,
  labelStyle,
  containerStyle,
  toolTipActiveOnHover,
  toolTipCustomStyle,
  placement,
  disableSmartPos,
  // Renders the red "*" every form in the app uses to mark a mandatory field.
  // The marker itself is hidden from screen readers (it reads as punctuation)
  // and replaced by the "(required)" text next to it.
  isRequired = false,
}) => {
  return (
    <div tw="flex gap-2 mb-2 items-center" css={containerStyle}>
      <span
        css={[
          tw`text-text_primary font-medium`,
          tw`max-md:text-sm max-md:text-text_secondary`,
          labelStyle,
        ]}
      >
        {label}
        {isRequired && (
          <>
            <span aria-hidden="true" tw="text-error ms-1">
              *
            </span>
            <span tw="sr-only">(required)</span>
          </>
        )}
      </span>
      {hasTooltip && (
        <TooltipIcon
          text={tooltipText}
          isActiveOnHover={toolTipActiveOnHover}
          placement={placement}
          disableSmartPos={disableSmartPos}
          toolTipCustomStyle={toolTipCustomStyle}
        />
      )}
    </div>
  );
};

export default LabelWithTooltip;
